<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Export partner(s)</h4>
</div>
<div class="form-group modal-body">
    Please choose which related information to include with the export.
    <br />
    <br />
    <div>
        <label>
            <input type="checkbox" [(ngModel)]="exportOptions.exportX12EdifactConfig" />&nbsp;EDI configurations
        </label>
    </div>
    <div>
        <label>
            <input type="checkbox" [(ngModel)]="exportOptions.exportContacts" />&nbsp;Contacts
        </label>
    </div>
    <div>
        <label>
            <input type="checkbox" [(ngModel)]="exportOptions.exportConfigurationKeys" />&nbsp;Configuration keys
        </label>
    </div>
    <div>
        <label>
            <input type="checkbox" [(ngModel)]="exportOptions.exportTags" />&nbsp;Tags
        </label>
    </div>
    <div>
        <label>
            <input type="checkbox" [(ngModel)]="exportOptions.exportProxyRelations" />&nbsp;Proxy settings
        </label>
    </div>
    <div>
        <label>
            <input type="checkbox" [(ngModel)]="exportOptions.exportTransportOutConfig" />&nbsp;Locations
        </label>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="ok()">Ok</button>
    <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
</div>